import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ImmoOverviewStateService } from '../../../../services/immo-overview-state.service';

@Component({
  selector: 'immo-print-tables',
  templateUrl: './immo-print-tables.component.html',
  styleUrls: ['./immo-print-tables.component.scss']
})
export class ImmoPrintTablesComponent implements OnInit {
  selectedOverview: string;

  countPrint: number = 0;
  countText: number = 0;

  @Output()
  countChange = new EventEmitter<number>();

  constructor(private immoOverviewStateService: ImmoOverviewStateService) {}

  ngOnInit() {
    this.selectedOverview = this.immoOverviewStateService.getSelectedPrintView();
  }

  changeSelectedView(value: string): void {
    this.selectedOverview = value;
    this.immoOverviewStateService.setSelectedPrintView(value);
  }

  updatePrintCount(count: number): void {
    this.countPrint = count;
    this.emitSummedCount();
  }

  updateTextCount(count: number): void {
    this.countText = count;
    this.emitSummedCount();
  }

  emitSummedCount(): void {
    const summedCount: number = this.countPrint + this.countText;
    this.countChange.emit(summedCount);
  }
}
